export default function getInfoEndpoints(build) {
  return {
    getWhoAmI: build.query({
      query: () => `/Info/whoAmI`,
    }),
  };
}
